// extracted by mini-css-extract-plugin
export default {"container":"UserCard_container__H4+cZ","textContainer":"UserCard_textContainer__Yh82M"};